import { IItemOrcamento } from "app/types/IItemOrcamento";
import store from "../store/store";

export function obterItemOrcamentoDaStore(identificadorItem:number) : IItemOrcamento {
    return (store.getState().orcamento.ItensOrcamento ?? []).find(i => i.Identificador == identificadorItem)
}